import React from 'react';
import TouchableElement from '@components/common/touchableElement';
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';
import Svg, { SVGIconProps } from '@styles/icons/svg';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import I18n from 'i18n-js';
import { SimpleOnPress } from '@interfaces/base';

type IconPropsType = Omit<SVGIconProps, 'icon' | 'C'>;

export interface LargeAddButtonProps extends Partial<SimpleOnPress> {
  C: ColorFunction;
  scale?: ScaleFunction;
  style?: StyleProp<ViewStyle>;
  font?: typeof initialFont;
  iconName?: string | null;
  iconStyle?: IconPropsType;
  title: string;
  titleStyle?: StyleProp<TextStyle>;
  titleIconName?: string;
  titleIconStyle?: IconPropsType;
}

const LargeAddButton = ({
  C,
  style,
  title,
  titleIconStyle,
  iconStyle,
  onPress,
  titleIconName,
  titleStyle,
  iconName = 'plusWithCircle',
  scale = initialScale,
  font = initialFont,
}: LargeAddButtonProps) => {
  return (
    <TouchableElement onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              backgroundColor: C(pressHoverColor('Button/Light/Primary')),
              borderRadius: scale(18),
              paddingHorizontal: scale(15),
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: scale(360),
              width: '100%',
              height: scale(96),
              gap: scale(10),
              minWidth: scale(200),
            },
            style,
          ]}
        >
          {iconName ? (
            <Svg
              {...iconStyle}
              icon={iconName}
              color={C(pressHoverColor(iconStyle?.color ?? 'Button/Light/Primary Text'))}
              width={scale(iconStyle?.width ?? 27)}
              height={scale(iconStyle?.width ?? 27)}
            />
          ) : null}

          <View
            style={{
              flexDirection: 'row',
              gap: scale(6),
            }}
          >
            {titleIconName ? (
              <Svg
                {...titleIconStyle}
                icon={titleIconName}
                color={C(pressHoverColor(titleIconStyle?.color ?? 'Button/Light/Primary Text'))}
                width={scale(titleIconStyle?.width ?? 22)}
                height={scale(titleIconStyle?.width ?? 22)}
              />
            ) : null}
            <Text style={[font['Headline Large'], { color: C('Button/Light/Primary Text'), fontSize: scale(18) }, titleStyle]}>{I18n.t(title)}</Text>
          </View>
        </View>
      )}
    </TouchableElement>
  );
};

export default LargeAddButton;
